export enum OfferType {
  SECOND_LOAN = 'SECOND_LOAN',
  RESUME_APPLICATION = 'RESUME_APPLICATION',
  CREDIT_CARD = 'CREDIT_CARD',
  REWARDS_CREDIT_CARD_B = 'REWARDS_CREDIT_CARD_B',
  STANDARD_CREDIT_CARD = 'STANDARD_CREDIT_CARD',
  REWARDS_CREDIT_CARD_A = 'REWARDS_CREDIT_CARD_A',
  BEFH_CTA = 'BEFH_CTA',
  SECURED_HOME_REFINANCE_LOAN = 'SECURED_HOME_REFINANCE_LOAN',
  UNSECURED_REFINANCE_LOAN = 'UNSECURED_REFINANCE_LOAN',
  SECURED_HOME_LOAN = 'SECURED_HOME_LOAN',
  INVITATION_TO_APPLY = 'INVITATION_TO_APPLY',
}

export type OffersSource = 'hub' | 'offers';

export enum OfferKey {
  OFFERS_UPL_CASHOUT_REFINANCE_SINGLE_LOAN = 'OFFERS_UPL_CASHOUT_REFINANCE_SINGLE_LOAN',
  OFFERS_HSL_CASHOUT_REFINANCE_SINGLE_LOAN = 'OFFERS_HSL_CASHOUT_REFINANCE_SINGLE_LOAN',
  OFFERS_SECOND_LOAN_ONLY = 'OFFERS_SECOND_LOAN_ONLY',
  OFFERS_REFINANCE_UNSECURED_PERSONAL_LOAN = 'OFFERS_REFINANCE_UNSECURED_PERSONAL_LOAN',
  OFFERS_ITA_REFINANCE_SINGLE_LOAN = 'OFFERS_ITA_REFINANCE_SINGLE_LOAN',
  OFFERS_ITA_REFINANCE_MULTI_LOAN = 'OFFERS_ITA_REFINANCE_MULTI_LOAN',
  OFFERS_UPL_PASSIVE_REFINANCE_SINGLE_LOAN = 'OFFERS_UPL_PASSIVE_REFINANCE_SINGLE_LOAN',
  OFFERS_HSL_PASSIVE_REFINANCE_SINGLE_LOAN = 'OFFERS_HSL_PASSIVE_REFINANCE_SINGLE_LOAN',
  OFFERS_UPL_PASSIVE_REFINANCE_MULTI_LOAN = 'OFFERS_UPL_PASSIVE_REFINANCE_MULTI_LOAN',
  OFFERS_HSL_PASSIVE_REFINANCE_MULTI_LOAN = 'OFFERS_HSL_PASSIVE_REFINANCE_MULTI_LOAN',
  OFFERS_PASSIVE_AND_SECOND_OPTIN = 'OFFERS_PASSIVE_AND_SECOND_OPTIN',
  OFFERS_PASSIVE_INVALID_AND_SECOND = 'OFFERS_PASSIVE_INVALID_AND_SECOND',
  OFFERS_PASSIVE_ERROR_AND_SECOND = 'OFFERS_PASSIVE_ERROR_AND_SECOND',
  OFFERS_PASSIVE_AND_SECOND = 'OFFERS_PASSIVE_AND_SECOND',
  OFFERS_PASSIVE_AND_SECOND_HSL = 'OFFERS_PASSIVE_AND_SECOND_HSL',
  OFFERS_RESUMABLE_APP = 'RESUMABLE_APP',

}

export enum HubOfferKey {
  HUB_SECOND_LOAN_ONLY = 'HUB_SECOND_LOAN_ONLY',
  HUB_REFINANCE_UNSECURED_PERSONAL_LOAN = 'HUB_REFINANCE_UNSECURED_PERSONAL_LOAN',
  HUB_PASSIVE_AND_SECOND_OPTIN = 'HUB_PASSIVE_AND_SECOND_OPTIN',
  HUB_PASSIVE_INVALID_AND_SECOND = 'HUB_PASSIVE_INVALID_AND_SECOND',
  HUB_PASSIVE_ERROR_AND_SECOND = 'HUB_PASSIVE_ERROR_AND_SECOND',
  HUB_PASSIVE_AND_SECOND = 'HUB_PASSIVE_AND_SECOND',
  HUB_PASSIVE_AND_SECOND_HSL = 'HUB_PASSIVE_AND_SECOND_HSL',
  HUB_ITA_REFINANCE_SINGLE_LOAN = 'HUB_ITA_REFINANCE_SINGLE_LOAN',
  HUB_HSL_PASSIVE_REFINANCE_SINGLE_LOAN = 'HUB_HSL_PASSIVE_REFINANCE_SINGLE_LOAN',
  HUB_UPL_PASSIVE_REFINANCE_SINGLE_LOAN = 'HUB_UPL_PASSIVE_REFINANCE_SINGLE_LOAN',
  HUB_UPL_CASHOUT_REFINANCE_SINGLE_LOAN = 'HUB_UPL_CASHOUT_REFINANCE_SINGLE_LOAN',
  HUB_HSL_CASHOUT_REFINANCE_SINGLE_LOAN = 'HUB_HSL_CASHOUT_REFINANCE_SINGLE_LOAN',
  HUB_ITA_REFINANCE_MULTI_LOAN = 'HUB_ITA_REFINANCE_MULTI_LOAN',
  HUB_HSL_PASSIVE_REFINANCE_MULTI_LOAN = 'HUB_HSL_PASSIVE_REFINANCE_MULTI_LOAN',
  HUB_UPL_PASSIVE_REFINANCE_MULTI_LOAN = 'HUB_UPL_PASSIVE_REFINANCE_MULTI_LOAN',
  RESUMABLE_APP = 'RESUMABLE_APP',
}

export const SubProductType = {
  SECURED_HOME_LOAN: 'SECURED_HOME_LOAN',
  UNSECURED_LOAN: 'UNSECURED_LOAN',
  UNSECURED_REFINANCE_LOAN: 'UNSECURED_REFINANCE_LOAN',
  SECURED_HOME_REFINANCE_LOAN: 'SECURED_HOME_REFINANCE_LOAN',
} as const;

export type SubProductType = (typeof SubProductType)[keyof typeof SubProductType];

export const isRefiOfferType = (offerType: OfferType | undefined): boolean =>
  offerType === OfferType.UNSECURED_REFINANCE_LOAN ||
  offerType === OfferType.SECURED_HOME_REFINANCE_LOAN;

export const isSecondLoanOrIta = (offer: Offer | null | undefined): boolean => {
  if (!offer?.offerType) return false;
  return offer.offerType === OfferType.SECOND_LOAN || offer.offerType === OfferType.INVITATION_TO_APPLY;
};

const OFFER_KEYS_WITH_MIN_APR_IN_TITLE = new Set<string>([
  OfferKey.OFFERS_HSL_PASSIVE_REFINANCE_SINGLE_LOAN,
  OfferKey.OFFERS_UPL_PASSIVE_REFINANCE_SINGLE_LOAN,
  OfferKey.OFFERS_HSL_PASSIVE_REFINANCE_MULTI_LOAN,
  OfferKey.OFFERS_UPL_PASSIVE_REFINANCE_MULTI_LOAN,
  HubOfferKey.HUB_HSL_PASSIVE_REFINANCE_SINGLE_LOAN,
  HubOfferKey.HUB_UPL_PASSIVE_REFINANCE_SINGLE_LOAN,
  HubOfferKey.HUB_UPL_PASSIVE_REFINANCE_MULTI_LOAN,
  HubOfferKey.HUB_HSL_PASSIVE_REFINANCE_MULTI_LOAN,
  HubOfferKey.HUB_PASSIVE_AND_SECOND_HSL,
]);

export const shouldShowMinAprInTitle = (offer: Offer | null | undefined): boolean =>
  !!offer?.minApr && OFFER_KEYS_WITH_MIN_APR_IN_TITLE.has(offer.offerKey);

export interface Offer {
  offerType: OfferType;
  offerKey: OfferKey | HubOfferKey;
  offerUrl: string;
  heading: string;
  label?: string;
  maxAmount?: number;
  minLoanAmount?: number;
  minApr?: number;
  maxApr?: number;
  callToAction?: string;
  productType?: string;
  subProductType?: string;
  approvalDisclosure?: string;
  approvalBadge?: string;
}

export interface OfferEvent {
  eventName: string;
  cid: string;
  cpid?: string;
  loanleadid?: string;
  utmMedium?: string;
  utmSource?: string;
  utmCampaign?: string;
  secondLoanOfferType: string;
}
